import * as Yup from "yup";

export const createCorporateCodeValidationSchema = Yup.object().shape({
  corporateName: Yup.string()
    .trim()
    .min(2, "Corporate name must be at least 2 characters")
    .max(100, "Corporate name is too long")
    .required("Corporate name is required"),

  corporateCode: Yup.string()
    .trim()
    .min(3, "Corporate code must be at least 3 characters")
    .max(20, "Corporate code is too long")
    .required("Corporate code is required"),

  pincode: Yup.string()
    .nullable()
    .matches(/^[0-9]{4,10}$/, {
      message: "Invalid pincode",
      excludeEmptyString: true,
    }),

  countryId: Yup.string()
    .nullable()
    .required("Country is required"),

  stateId: Yup.string()
    .nullable()
    .required("State is required"),

  cityId: Yup.string()
    .nullable()
    .required("City is required"),

});


export const updateCorporateCodeValidationSchema = Yup.object().shape({
  corporateName: Yup.string()
    .trim()
    .min(2, "Corporate name must be at least 2 characters")
    .max(100, "Corporate name is too long")
    .required("Corporate name is required"),

  corporateCode: Yup.string()
    .trim()
    .min(3, "Corporate code must be at least 3 characters")
    .max(20, "Corporate code is too long")
    .required("Corporate code is required"),

  pincode: Yup.string()
    .nullable()
    .matches(/^[0-9]{4,10}$/, {
      message: "Invalid pincode",
      excludeEmptyString: true,
    }),

  countryId: Yup.string().nullable().required("Country is required"),
  stateId: Yup.string().nullable().required("State is required"),
  cityId: Yup.string().nullable().required("City is required"),

});
